// Texto discreto "Atualizado às HH:MM" — prova visual de que a atualização automática
// (useAutoRefresh, Lote 57) está de fato funcionando. Pedido do Robson (02/10/2026):
// "não percebi a atualização de tempo em tempo... isso está funcionando?" — o mecanismo
// sempre funcionou, mas era silencioso de propósito (sem spinner), então não dava pra
// confirmar na tela. Esse rótulo não pisca nem chama atenção, só fica ali pra quem quiser
// conferir.
export default function LastUpdatedLabel({ date, className = "" }) {
  if (!date) return null;
  const pad = (n) => String(n).padStart(2, "0");
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return (
    <span className={`text-[11px] text-stone-400 tabular-nums ${className}`}>
      Atualizado às {time}
    </span>
  );
}
